import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { className: "-mx-0.5" }

import VButton from '@/components/Buttons/VButton.vue'

	import { 
		clsx
	} from 'clsx'

	
	const __default__ = { name: 'VPaginationPage' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		ariaLabel: {
			type: String,
			default: 'Page navigation'
		},
		className: {
			type: String,
			default: ''
		},
		current: {
			type: Boolean,
			default: false
		},
		href: {
			type: String,
			default: null
		}
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VButton, {
    href: __props.href,
    plain: "",
    "aria-label": `Page `,
    "aria-current": __props.current ? 'page' : undefined,
    class: _normalizeClass(_unref(clsx)(
			__props.className,
			'min-w-[2.25rem] before:absolute before:-inset-px before:rounded-lg',
			__props.current && 'before:bg-zinc-950/5 dark:before:bg-white/10'))
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["href", "aria-current", "class"]))
}
}

})